import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ItemGroups, ItemUrls, Collection, Training } from '../app.urls';

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  itemStatus: any;
  public updateItemName = new Subject<any>();
  private updateStatusSource = new BehaviorSubject<any>('');
  public updateStatus = this.updateStatusSource.asObservable();
  private getItemUuid = new BehaviorSubject<any>('');
  public itemdata = this.getItemUuid.asObservable();
  private getItemQuestionCount = new BehaviorSubject<any>('');
  public itemQCount = this.getItemQuestionCount.asObservable();
  private newCreatedItem = new BehaviorSubject<any>('');
  public getCretedItem = this.newCreatedItem.asObservable();
  private editCreatedItem = new BehaviorSubject<any>('');
  public getEditedItem = this.editCreatedItem.asObservable();
  questionCountUpdate = new BehaviorSubject<any>(null);
  public itemgrouplist = new BehaviorSubject<any>('');
  public Allitemgrouplist = this.itemgrouplist.asObservable();
  public itemDetails = new BehaviorSubject<any>('');
  public ItemBasicDetails = this.itemDetails.asObservable();

  public StyleList = new BehaviorSubject<any>('');
  public StyleListData = this.StyleList.asObservable();
  public styleGroup = new BehaviorSubject<any>('');
  public styleGroupList = this.styleGroup.asObservable();
  public itemStatusList = new BehaviorSubject<any>('');
  public getItemStatusList = this.itemStatusList.asObservable();

  public selectedQuestionTab = new BehaviorSubject<any>('');
  public getSelectedQuestionTab = this.selectedQuestionTab.asObservable();

  public ScoringTypeId = new BehaviorSubject<any>('');
  public getScoringTypeId = this.ScoringTypeId.asObservable();

  public fileName = new BehaviorSubject<any>('');
  public getfileName = this.fileName.asObservable();

  public videoIcon = new BehaviorSubject<any>(true);

  public imageUploadErr = new BehaviorSubject<any>(false);
  public getImageUploadErr = this.imageUploadErr.asObservable();

  public imageSizeErr = new BehaviorSubject<any>(false);
  public getImageSizeErr = this.imageSizeErr.asObservable();

  constructor(private http: HttpClient) { }

  getItemuuid(item: any) {
    this.getItemUuid.next(item);
  }

  itemQuestionCount(itemQuestionCount) {
    this.getItemQuestionCount.next(itemQuestionCount);
  }
  createdGetItem(item1: any) {
    this.newCreatedItem.next(item1);
  }

  editedGetItem(item2: any) {
    this.editCreatedItem.next(item2);
  }

  updateItemBankName(value: any) {
    this.updateItemName.next(value);
  }

  updateItemStatus(isPublishedStatus: any): void {
    this.updateStatusSource.next(isPublishedStatus);
  }

  getItem(collectionUUID: string): Observable<any> {
    return this.http.get<any>(ItemUrls.GetItem + '?collectionUUID=' + `${collectionUUID}`);

  }

  getScoringTypes() {
    return this.http.get<any>(ItemUrls.getScoringType);
  }

  getItemDetails(itemId: string) {
    return this.http.get<any>(ItemUrls.getItemDetails + `${itemId}`);
  }

  getTags(itemUUID: string) {
    return this.http.get<any>(ItemUrls.getItemDetails + `${itemUUID}/tags`);
  }

  itemOrder(testUUID: string, data: any) {
    return this.http.put<any>(ItemUrls.ItemOrder + `${testUUID}/arrangeOrder`, data);
  }

  getDifficultyLevel() {
    return this.http.get<any>(ItemUrls.DifficultyLevel);
  }

  getItemStatus() {
    return this.http.get<any>(ItemUrls.ItemStatus);
  }

  getItemByQuery(collectionId: string, testId: string, options: string = ''): Observable<any> | null {
    const fetchItemApiUrl = ItemUrls.ItemByQuery + '?collectionuuId=' + collectionId + '&testuuId=' + testId + options;
    return this.http.get<any>(fetchItemApiUrl)
  }



  // THis service used for only search filter on item landing page.
  getItemFilter(item: any): Observable<any> | null {
    const fetchItemapiUrl = ItemUrls.ItemFilter + '?collectionuuId=' + item.collectionuuid + '&itemBankName=' + item.itemName + '&itemDescription=' + item.itemDescription + '&itemStatus=' + item.itemStatus + '&tag=' + item.tag;

    return this.http.get<any>(fetchItemapiUrl)
  }

  // THis service used for only search filter test-existing-item page.
  getItemTestFilter(item: any): Observable<any> | null {
    const fetchItemapiUrl = ItemUrls.ItemByQuery + '?collectionuuId=' + item.collectionuuid + '&testuuId=' + item.testuuId + '&itemBankName=' + item.itemName + '&itemDescription=' + item.itemDescription + '&itemStatus=' + item.itemStatus + '&tag=' + item.tag;

    return this.http.get<any>(fetchItemapiUrl)
  }



  updateItem(Item: any) {
    Object.defineProperty(Item, "itemBankId", { enumerable: false });
    const dataToApi = JSON.stringify(Item);
    return this.http.put<any>(ItemUrls.UpdateItem + Item?.itemBankId, dataToApi, { 'headers': { 'content-type': 'application/json'} })
  }

  addNewItem(collectionId: any, itemBankName: any, itemDescription: any, scoringTypeId: any, styleGroupId: any) {
    const addNewItem = {
      "collectionuuId": collectionId,
      "itemBankName": itemBankName,
      "itemDescription": itemDescription,
      "ScoringTypeId": parseInt(scoringTypeId),
      "StyleGroupID": parseInt(styleGroupId)
    }
    return this.http.post<any>(ItemUrls.AddNewItem, JSON.stringify(addNewItem), { 'headers': { 'content-type': 'application/json'} })
  }

  getAllTagsForItem(collectionuuId: any, itemuuId: any, keyword: string) {
    if (typeof keyword !== 'string') {
      keyword = " ";
    }
    const fetchTagsapiUrl = ItemUrls.AllTagsForItem + 'items?collectionuuId=' + collectionuuId + '&itemuuId=' + itemuuId + '&keyword=' + keyword;

    return this.http.get<any>(fetchTagsapiUrl)
  }

  addTag(itemId: any, taguuId: any, tagOrder: any) {
    const dataToApi = {
      "taguuId": taguuId,
      "tagOrder": tagOrder
    }
    return this.http.post<any>(ItemUrls.getItemDetails + itemId + "/tags", JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json'} })
  }

  updateItemSetting(Item: any) {
    const dataToApi = JSON.stringify(Item);
    return this.http.put<any>(ItemUrls.UpdateItemSetting + Item, dataToApi, { 'headers': { 'content-type': 'application/json'} })
  }

  AddItemSetting(Item: any, level: any, status: any, shuffle: boolean, collectionuuId: any) {
    const dataToApi = { "collectionuuId": collectionuuId, "difficultylevelId": level, "statusId": status, "shuffle": shuffle };

    return this.http.put<any>(ItemUrls.UpdateItemSetting + Item, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json'} })
  }

  deleteTagOfItem(itemtagId: any, itemuuId: any) {
    const deleteItemTagApiUrl = ItemUrls.DeleteTagOfItem + itemuuId + '/tags/' + itemtagId;
    return this.http.delete<any>(deleteItemTagApiUrl)
  }

  arrangeOrder(itemuuId: any, payload: any) {
    const orderApiUrl = ItemUrls.ArrangeOrder + itemuuId + '/arrangeOrder';
    return this.http.put<any>(orderApiUrl, JSON.stringify(payload), { 'headers': { 'content-type': 'application/json'} })
  }

  arrangeOrderForStemOption(questionuuid, payload, type) {
    if (type == 'options') {
      return this.http.put<any>(ItemUrls.ArrangeOrDerForStemOption + `${questionuuid}/arrangeorderforoptions`, payload)
    } else {
      return this.http.put<any>(ItemUrls.ArrangementOfStem, payload)
    }
  }

  arrangeOrderForOptions(questionuuid, payload) {
    return this.http.put<any>(ItemUrls.ArrangeOrDerForStemOption + `${questionuuid}/arrangeorderforoptions`, payload)
  }

  getItemGroupList(testUUID: any) {
    return this.http.get<any>(ItemGroups.itemGroupList + `${testUUID}`);
  }

  createItemGroup(testUUID: any, data: any) {
    const addNewgroup = {
      "itemGroupName": data.itemGroupName,
      "enableQuestionSequencing": data.enableQuestionSequencing,
      "description": data.description,
      "itemGroupId": data.itemGroupId,
      "scoringTypeID": data.scoringTypeId,
      "styleGroupID": data.styleGroupId
    }
    return this.http.post<any>(ItemGroups.createItemGroup + `${testUUID}`, addNewgroup, { 'headers': { 'content-type': 'application/json' } });
  }

  deleteItemGroup(testUUID: any, itemGroupId: any) {
    return this.http.delete<any>(ItemGroups.deleteItemGroup + `${testUUID}` + '/' + `${itemGroupId}`);
  }

  updateItemGroup(testUUID: any, data: any) {
    const addNewgroup = {
      "itemGroupName": data.itemGroupName,
      "enableQuestionSequencing": data.enableQuestionSequencing,
      "description": data.description,
      "itemGroupId": data.itemGroupId,
      "scoringTypeID": data.scoringTypeId,
      "styleGroupID": data.styleGroupId
    }
    return this.http.put<any>(ItemGroups.updateItemGroup + `${testUUID}`, addNewgroup);
  }

  saveOrderItemGroup(testUUID: any, data: any) {
    return this.http.put<any>(ItemGroups.orderItemGroup + `${testUUID}` + '/item-group-arrange-order', data);
  }

  getStylesBasedOnStyleGroup(itemuuid, styleGroupId) {
    return this.http.get<any>(ItemUrls.AddQuestion + `${itemuuid}/questions/style-list/${styleGroupId}`);
  }

  getStyleGroups(globalcollectionuuId) {
    return this.http.get<any>(ItemUrls.getStyleList + '?collectionId=' + globalcollectionuuId);
  }

  getQuestionSubtypes() {
    return this.http.get<any>(ItemUrls.questionSubtypes);
  }

  getQuestionTypes() {
    return this.http.get<any>(ItemUrls.questionTypes);
  }

  getStatusList() {
    return this.http.get<any>(ItemUrls.statusList)
  }

  deleteItem(itemid) {
    return this.http.delete<any>(ItemUrls.deleteItem + itemid );
  }

  videoTutorial(assetGroup) {
    return this.http.get<any>(Training.tutorial + assetGroup);
  }
}
